<template>
  <div class="material-code">
    <a-tabs type="card" v-model:activeKey="activeKey" @change="handleChange">
      <template v-for="item in materialTypeOptins" :key="item.value">
        <a-tab-pane :tab="item.label">
          <materila-table v-if="activeKey === item.value"></materila-table>
        </a-tab-pane>
      </template>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, provide, ref, onActivated, onDeactivated } from "vue";
import { useRoute, useRouter } from 'vue-router';
import materilaTable from "@/views/materialcode/table.vue";
import { materialTypeOptins } from "@/views/materialcode/options";
import Cookie from 'js-cookie';

export default defineComponent({
  name: "rdMaterialCode",
  components: { materilaTable },
  setup() {
    const activeKey = ref(materialTypeOptins[0].value);
    provide("activeKey", activeKey);

    const handleChange = () => {
      Cookie.remove('materailParams');
    };

    onDeactivated(() => {
      Cookie.set('materailTabKey', JSON.stringify({
        activeKey: activeKey.value
      }));

    });

    onActivated(() => {
      const objString = Cookie.get('materailTabKey');

      if (objString) {
        const obj = JSON.parse(objString);
        activeKey.value = obj.activeKey;
      }

    });

    return { activeKey, materialTypeOptins, handleChange };
  },
});
</script>

<style lang="less" scoped>
.material-code {
  background: #fff;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 15px;
}
</style>
